import React from 'react'
import './BHomeCard.css'
import influImg from '../images/45.png'
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import StarIcon from '@mui/icons-material/Star';
const BHomeCard = (props)=> {
        function handleClick(){

        }
        let {rating, followers, platform} = props;
        return(
            <>
                <div className='b2-cardBorder' onClick={handleClick}>
                <a href='/view-influencer' className='b2-link'></a>
                    <img src={influImg} alt='influencer' className='b2-background'></img> {/*"/images/45.png"*/}
                    <div className='b2-upperDiv'>
                        <span className='b2-rating'>{rating}</span>
                        <StarIcon className='b2-star'/>
                        {/* <img src='/images/star.png' alt='star'  width='30px' height='30px'></img> */}
                    </div>
                    <div className='b2-lowerDiv'>
                        {(platform=='youtube')?
                        <YouTubeIcon  className='b2-social'/>:<InstagramIcon  className='b2-social'/>}
                       {/*  <img src={platform==='youtube'?'/images/youtube.png':'/images/instagram.png'} alt='followers' className='b2-social' width='10px' height='10px'></img> {/*"/images/instagram.png"*/}
                        <span className='b2-followers'>{followers}</span>
                    </div>
                </div>
            </>
        )
}

export default BHomeCard